
function trackEvent(eventName, properties = {}) {
	if (window.fbq && typeof window.fbq === "function") {
		window.fbq("track", eventName, properties);
	}
}

export default {
	trackEvent,
};



// WEBPACK FOOTER //
// ./src/analytics/util/FBPixel/index.js